import { ref } from 'vue';
import type { CustomerProfile } from '@/types';

type ImpersonateData = Pick<CustomerProfile, 'fullName' | 'fileNumber' | 'administrativeNote' | 'disability'>;

const impersonateData = ref<ImpersonateData>({
  fullName: '',
  fileNumber: '',
  administrativeNote: '',
  disability: null,
});

export default function useImpersonateData() {
  function setImpersonateData(data: CustomerProfile) {
    impersonateData.value = {
      fullName: data.fullName,
      fileNumber: data.fileNumber,
      administrativeNote: data.administrativeNote,
      disability: data.disability,
    };
  }

  return {
    setImpersonateData,
    impersonateData: impersonateData,
  };
}
